<section id="navbar-menu-trigger"></section>

<div class="enku-navbar">
  @if (canSwitchRole) {
    <div class="enku-navbar-role-dropdown" ngbDropdown placement="bottom-end">
      <button
        type="button"
        class="enku-navbar-role-trigger"
        ngbDropdownToggle
        [disabled]="isSwitchingRole"
        aria-label="เลือกสิทธิ์การใช้งาน"
      >
        <span>{{ displayName }}</span>
        <app-keenicon name="down" class="enku-navbar-role-trigger-icon"></app-keenicon>
      </button>

      <div class="enku-navbar-role-menu" ngbDropdownMenu>
        @for (role of availableRoles; track role.id) {
          <button
            type="button"
            class="enku-navbar-role-option"
            [class.active]="role.id === activeRoleId"
            [disabled]="isSwitchingRole || role.id === activeRoleId"
            ngbDropdownItem
            (click)="onRoleChange(role)"
          >
            <span>{{ role.name_th || role.label || role.name }}</span>
            @if (role.id === activeRoleId) {
              <app-keenicon name="check" class="enku-navbar-role-option-check"></app-keenicon>
            }
          </button>
        }
      </div>
    </div>
  } @else {
    <span class="enku-navbar-user">{{ displayName }}</span>
  }
  <span class="enku-navbar-divider"></span>
  <button type="button" class="enku-navbar-logout" (click)="logout()">
    <app-keenicon name="exit-right" class="fs-4"></app-keenicon>
    <span>ออกจากระบบ</span>
  </button>
</div>
